export default __webpack_public_path__ + "e2d44ebd30f23c475ae48ca939241029.svg";